export const ACTIVE_REPORT = 'ACTIVE_REPORT';
export const ACTIVE_ALERTS_TAB = 'ACTIVE_ALERTS_TAB';

export function alertsTab(activeAlertTab: $TSFixMe) {
  return {
    type: ACTIVE_ALERTS_TAB,
    activeAlertTab,
  };
}
